import React, { useEffect, useState } from 'react'

import { CalculationProps, RequiredParamsProps } from '../../types/MedicalCalculations'
import CalculationCard from './CalculationCard'
import { useAuth } from '../../context/AuthContext'

type Props = CalculationProps & {
  setGfr: (gfr: string) => void
}

const GFRByCystatinCS: React.FC<Props> = (props) => {
  const [data, setData] = useState<string | undefined>(undefined)
  const [requiredParams, setRequiredParams] = useState<RequiredParamsProps>({})
  const [isLoading, setIsLoading] = useState<boolean>(true)

  const { backendRequest } = useAuth()

  useEffect(() => {
    setIsLoading(true)

    const reqParamsObj = {
      age: props.formData.age,
      gender: props.formData.gender,
      cystatin_c_s: props.formData.cystatin_c_s,
    }
    setRequiredParams(reqParamsObj)

    const allParamsPresent = Object.values(reqParamsObj).every((value) => {
      if (value === null || value === undefined || value === '') {
        return false
      }
      return true
    })

    const getData = async () => {
      if (allParamsPresent) {
        const response = await backendRequest({
          method: 'GET',
          endpoint: '/api/medical-calculations/gfr-by-cystatin-c-s',
          requiresAuth: true,
          params: {
            age: props.formData.age,
            gender: props.formData.gender,
            cystatin_c_s: props.formData.cystatin_c_s,
          },
        })
        return response
      } else {
        return undefined
      }
    }
    getData().then((response) => {
      if (response && response.status === 200) {
        setData(response.data)
        props.setGfr(response.data)
      } else {
        setData(undefined)
      }
      setIsLoading(false)
    })
  }, [props.formData])

  return (
    <CalculationCard
      title='GFR (CKD-EPI) by cystatin C - S'
      value={data}
      units='ml/s/1.73m<sup>2</sup>'
      requiredParams={requiredParams}
      isLoading={isLoading}
      formData={props.formData}
      setFormData={props.setFormData}
    />
  )
}

export default GFRByCystatinCS
